import React from "react";
import { Container, Row, Col } from "react-bootstrap";
//import homeLogo from "../../Assets/home-main.svg";
import homeLogo from "../../Assets/mmmm.png"
import Particle from "../Particle";
import Home2 from "./Home2";
import Type from "./Type";
import {Helmet} from "react-helmet"
import Journay from "./Journay";

function Home() {
  return (
    <section>
      <Helmet>
         <title>Rahul Singh - Full Stack Developer</title>

         {/*Mete tag for SEO */}
         <meta name="description" content="Explore the portfolio of Rahul Singh, a Full Stack Developer showcasing web development projects, skills, and DSA notes." />
         
         <meta name="keywords" content= "Rahul Singh , portfolio , React Developer , Full Stack Developer  , Web Developer" />

         <meta name="author" content="Rahul Singh"/>

         {/* Open Graph Tag for Social Media */}
         <meta property="og:title" content="Rahul Singh - Full Stack Developer" />

         <meta property="og:description" content="Find Out latest Web developement Project || DSA Notes" />

         <meta property="og:image" content="https://rahulsingh.vercel.app/static/media/avatar.e7b5b9659e2771a59b2f.jpg" />

         <meta property="og:url" content="https://rahulsingh.vercel.app" />

         <meta property="og:type" content="website" />

         {/* Encoding */}
         <meta charSet="UTF-8" />
      </Helmet>

     {/* Hero Section */}
      <Container fluid className="home-section" id="home">
        <Container className="home-content">
          <Row>
            <Col md={7} className="home-header">
              <h1 className="heading-name">
                 Building Scalable Systems - I'm
                <strong className="main-name"> Rahul 
                 Kumar Singh</strong>
              </h1>

              <div style={{ padding: 50, textAlign: "left" }}>
                <Type />
              </div>
            </Col>

            <Col md={5} style={{ paddingBottom: 20 }}>
                <Journay/>
            </Col>
          </Row>
        </Container>
      </Container>

      {/* RESUME SECTION */}
      <Home2 />
    </section>
  );
}

export default Home;
